import { render, staticRenderFns } from "./buyCarNew.vue?vue&type=template&id=0c07a596&scoped=true&"
import script from "./buyCarNew.vue?vue&type=script&lang=js&"
export * from "./buyCarNew.vue?vue&type=script&lang=js&"
import style0 from "./buyCarNew.vue?vue&type=style&index=0&id=0c07a596&scoped=true&lang=scss&"
import style1 from "./buyCarNew.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07a596",
  null
  
)

export default component.exports